import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { EyeOffIcon } from 'lucide-react';
import { useProto } from '../../contexts/PrototypeContext';
import { Toggle } from '../shared/Toggle';
import { Annotation } from '../shared/Annotation';
import { DiscountAmountField } from './DiscountAmountField';
import { RoleCapacityTable } from './RoleCapacityTable';
import { VolunteerMessageField } from './VolunteerMessageField';
import { CustomerPreview } from './CustomerPreview';
const ease = [0.23, 1, 0.32, 1] as const;
export function DiscountCapacitySection() {
  const {
    state,
    actions
  } = useProto();
  const enabled = state.config.discountEnabled;
  return <section aria-labelledby="dcm-title" data-id="element-76" data-mp="2voog8fp1gxba">
      <div className="border-b border-connect-line pb-1.5" data-id="element-77" data-mp="2vnn2u4kjvyqe">
        <h3 id="dcm-title" className="text-[17px] font-medium text-connect-blue" data-id="element-78" data-mp="1g8fvqjnausnt">Discount &amp; Capacity Management</h3>
      </div>
      <Annotation kind="note" title="Self-contained, relocatable module" className="mt-3" data-id="element-79" data-mp="1kauiheu3ackd">
        Everything from the toggle through the customer preview is one block with no dependency on other Staffing fields, so it can move as the Programs flow is redesigned.
      </Annotation>

      <div className="mt-5 flex items-start justify-between gap-6 rounded-lg border border-connect-line px-5 py-4" data-id="element-80" data-mp="3kb6u7bcts61j">
        <div data-id="element-81" data-mp="3g8jxox57lwy0">
          <label htmlFor="offer-toggle" className="font-medium text-connect-ink" data-id="element-82" data-mp="3g7s41rv6a9ad">Offer Registration Discount</label>
          <p className="mt-0.5 text-sm text-connect-muted" data-id="element-83" data-mp="3u71fyfccih8j">
            Give families an immediate discount on this registration when they commit to volunteer.
          </p>
        </div>
        <Toggle id="offer-toggle" checked={enabled} onChange={v => actions.updateConfig({
        discountEnabled: v
      })} data-id="element-84" data-mp="7sqgeg320hfw" />
      </div>

      <AnimatePresence initial={false} mode="wait" data-id="element-85" data-mp="gu7uxu0tcb2h">
        {enabled ? <motion.div key="on" initial={{
        opacity: 0,
        y: -6
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -6
      }} transition={{
        duration: 0.2,
        ease
      }} className="mt-8 space-y-10" data-id="element-86" data-mp="guhp7tsw54dz">
            <DiscountAmountField data-id="element-87" data-mp="3amzexjslej8r" />
            <RoleCapacityTable data-id="element-88" data-mp="3ak3dhlhjdcfk" />
            <VolunteerMessageField data-id="element-89" data-mp="3en9laxkarbo5" />
            <CustomerPreview data-id="element-90" data-mp="3em88oonmuh4b" />
          </motion.div> : <motion.div key="off" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.15
      }} className="mt-4 flex items-start gap-3 rounded-lg bg-connect-canvas px-5 py-4 text-sm text-connect-muted" data-id="element-91" data-mp="3jf19j1fzd5b4">
            <EyeOffIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-92" data-mp="27pgclnwvw5q" />
            <p data-id="element-93" data-mp="689b5il0inop">
              Discount amount, role opportunities, and the volunteer message appear when this is on. Families won't see a Volunteer Registration Discount for this program.
              {state.config.coachCreditEnabled && ' Automated Coach Credit will display on the Volunteer Info step instead.'}
            </p>
          </motion.div>}
      </AnimatePresence>
    </section>;
}